import Skeleton from "react-loading-skeleton";

export function PartnerAnalyticsSkeleton() {
	return (
		<div className="space-y-8 mt-6">
			{/* Statistics Cards Skeleton */}
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
				{[...Array(4)].map((_, i) => (
					<div
						key={`stat-${i}`}
						className="rounded-xl border border-base-content/10 bg-base-100 p-6"
					>
						<div className="text-sm">
							<Skeleton width={100} />
						</div>
						<div className="mt-2">
							<Skeleton width={140} height={36} />
						</div>
						<div className="mt-1">
							<Skeleton width={80} />
						</div>
					</div>
				))}
			</div>

			{/* Chart Skeleton */}
			<div className="mt-8">
				<div className="flex items-center justify-between mb-4">
					<div>
						<Skeleton width={120} height={24} />
						<div className="mt-1">
							<Skeleton width={180} />
						</div>
					</div>
					<Skeleton width={120} height={36} borderRadius={8} />
				</div>
				<div className="h-75 rounded-xl border border-base-content/10 bg-base-100 p-4">
					<Skeleton height="100%" className="h-full" />
				</div>
			</div>

			{/* Apps Table Skeleton */}
			<div className="mt-8">
				<div className="mb-4">
					<Skeleton width={100} height={24} />
					<div className="mt-1">
						<Skeleton width={240} />
					</div>
				</div>
				<div className="rounded-xl border border-base-content/10 bg-base-100 overflow-hidden">
					<div className="h-11 border-b border-base-content/10 bg-base-100/50 flex items-center px-4">
						<Skeleton width={100} />
					</div>
					{[...Array(3)].map((_, i) => (
						<div
							key={`row-${i}`}
							className="h-16 border-b border-base-content/10 last:border-0 flex items-center px-4 gap-4"
						>
							<div className="flex-1">
								<Skeleton width={120} />
							</div>
							<div>
								<Skeleton width={80} borderRadius={9999} />
							</div>
							<div className="w-24 text-right">
								<Skeleton width={60} />
							</div>
							<div className="w-24 text-right">
								<Skeleton width={60} />
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
